import React from 'react';
import { render } from 'react-dom';
import CustomSelect from './custom-select';
import './css/index.css';

export default class {

    static name = 'custom-select';

    constructor( config ) {

        this.wrapper = config.element;
        this.attributes = config.attributes;

    }

    ready() {

        render(
            <CustomSelect
                attributes= { this.attributes }
            />, this.wrapper
        );

    }

}
